<template>
	<div class="account-form">
		<p class="slogan" :class="{ 'text-center': isHW() }">{{ pltform.welcome_msg }}</p>
		<div class="form">
			<el-form :model="login_form" ref="ruleFormRef">
				<el-form-item
					prop="mobile"
					:rules="[
						{ required: true, message: $t('login.pl_phone'), whitespace: true, trigger: 'change' },
					]"
				>
					<el-input
						style="margin-bottom: 10px"
						v-model="login_form.mobile"
						:placeholder="$t('login.pl_phone')"
						autocomplete="off"
					>
						<template #prepend v-if="isHW()">
							<AreaCode v-model="login_form.areaCode" @clear="clear" />
						</template>
					</el-input>
				</el-form-item>
				<el-form-item
					prop="password"
					:rules="[
						{
							required: true,
							message: $t('login.pl_password'),
							whitespace: true,
							trigger: 'change',
						},
					]"
				>
					<el-input
						v-model="login_form.password"
						:type="showPass ? 'text' : 'password'"
						:placeholder="$t('login.pl_password')"
						autocomplete="off"
						@keyup.enter.native="onSignIn"
					>
						<template #suffix>
							<i
								class="shopyy-iconfont shopyyicon-Invisible"
								style="cursor: pointer"
								:class="
									showPass
										? 'shopyy-iconfont shopyyicon-View'
										: 'shopyy-iconfont shopyyicon-Invisible'
								"
								@click="showPass = !showPass"
							>
							</i>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item
					prop="code"
					:rules="[
						{ required: true, message: $t('login.pl_code'), whitespace: true, trigger: 'change' },
					]"
					v-if="isHW()"
				>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-input
								v-model="login_form.code"
								:placeholder="$t('login.pl_code')"
								autocomplete="off"
							/>
						</el-col>
						<el-col :span="12">
							<Verification
								:formData="{
									sms: 'loginCode',
									are: login_form.areaCode,
									mobile: login_form.mobile,
								}"
							/>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
			<div class="form-btn">
				<div class="regist" v-if="!isHW()">
					<!-- <div>没有账号？<span @click="cutType('register')">注册</span></div> -->
					<div>
						<el-checkbox v-model="checked" :label="$t('login.free')" size="large" />
					</div>
					<div>
						<span @click="cutType('forget')">{{ $t('login.forget_password') }}?</span>
					</div>
				</div>
				<el-button type="primary" :loading="loading" @click="onSignIn">
					{{ $t('login.login') }}
				</el-button>
				<div v-if="isHW()" class="hw_pass">
					<span @click="cutType('forget')">{{ $t('login.forget_password') }}?</span>
				</div>
			</div>
		</div>
		<SMS :mobile="login_form.mobile" v-model="showSms" v-if="showSms" @confirm="getSms" />
		<MFA v-model="showMfa" v-if="showMfa" @confirm="getMfa" />
	</div>
</template>

<script lang="ts" setup>
import { ref, computed, getCurrentInstance } from 'vue'
import { login } from '../api/login'
import { useStore } from '/@/store'
import type { LogoType } from '../component/account/AccountLogin.vue'
import type { LoginForm } from '../types/login'
import { Cookies, Local, Session, TOKEN_NAME } from '/@/utils/storage'
import uploadUser from '@/utils/uploadUserInfo'
import { initFrontEndControlRoutes } from '/@/router/frontEnd'
import { useRoute, useRouter } from 'vue-router'
import { formatAxis } from '/@/utils/formatTime'
import { ElMessage } from 'element-plus'
import { getNowDomain } from '@/utils/config'
import { i18n } from '/@/i18n'
import Verification from './compoent/Verification.vue'
import AreaCode from './compoent/AreaCode.vue'
import { isHW } from '/@/utils'
import SMS from './compoent/SMS.vue'
import MFA from './compoent/MFA.vue'

const { t } = i18n.global
const store = useStore()
const pltform = computed(() => {
	return store.state.platForm
})
const checked = ref(Boolean(Cookies.get('free_of_charge')) || false)
const emits = defineEmits(['change'])
const login_form = ref<LoginForm>({
	mobile: Local.get('mobile') || '',
	password: '',
	brand_id: pltform.value.id,
	code: '',
	areaCode: '',
	expire: '1',
	platform: 'pc',
})

const route = useRoute()
const router = useRouter()
const showPass = ref(false)
const { proxy } = getCurrentInstance() as any

const ruleFormRef = ref()

//登录
const loading = ref(false)
const showSms = ref(false)
const showMfa = ref(false)
const onSignIn = () => {
	ruleFormRef.value.validate(async (valid) => {
		if (!valid) return
		try {
			const { data } = await login(
				{ ...login_form.value, brand_id: pltform.value.id, expire: checked.value ? '7' : '1' },
				loading
			)
			if (!data?.twofa) return
			switch (data?.twofa) {
				//1正常 2短信验证 3虚拟mfa
				case 1:
					Session.set(TOKEN_NAME, data?.token)
					Cookies.set(TOKEN_NAME, data?.token) //设置token
					Local.set('PASSWORD_STRENGTH', data?.password_check) //密码强度是否是弱密码为false是true不是
					await get_user()
					break
				case 2:
					showSms.value = true
					break
				case 3:
					showMfa.value = true
					break

				default:
					break
			}
		} catch (error) {
			login_form.value.code = ''
		}
	})
}

//获取用户信息
const get_user = async () => {
	try {
		await uploadUser()

		Local.set('mobile', login_form.value.mobile) //登录成功记住账号

		Cookies.set('watch_live_status', 1, { expires: 30, domain: getNowDomain() }) //后端需要此参数
		if (checked.value) {
			//如果设置了7天免登录需要记录本地cookies默认勾中选项
			Cookies.set('free_of_charge', true, { expires: 7, domain: getNowDomain() })
		} else {
			Cookies.set('free_of_charge', false)
		}

		// 1、请注意执行顺序(存储用户信息到vuex)
		//store.dispatch('userInfos/setUserInfos', data)
		i18n.global.locale = Local.get('account-font-userInfo')?.language || 'zh-cn'
		// 获取店铺版本信息；请求本地路由信息
		await initFrontEndControlRoutes()
		// 执行完 initBackEndControlRoutes，再执行 signInSuccess
		signInSuccess()
	} catch (error) {
		Cookies.remove() //设置token
	}
}
const signInSuccess = () => {
	if (route.query?.redirect && route.query?.redirect.includes('register')) {
		router.push('/')
		return
	}
	// 登录成功，跳到转首页
	// 添加完动态路由，再进行 router 跳转，否则可能报错 No match found for location with path "/"
	// 如果是复制粘贴的路径，非首页/登录页，那么登录成功后重定向到对应的路径中
	if (route.query?.redirect) {
		router.push({
			path: route.query?.redirect as string,
			query:
				Object.keys(route.query?.params as any).length > 0
					? JSON.parse(route.query?.params as any)
					: '',
		})
	} else {
		router.push('/')
	}
	// 登录成功提示
	setTimeout(() => {
		// 关闭 loading
		const currentTime = formatAxis(new Date())
		const signInText = t('login.login_success')
		ElMessage.success(`${currentTime}，${signInText}`)
		// 修复防止退出登录再进入界面时，需要刷新样式才生效的问题，初始化布局样式等(登录的时候触发，目前方案)
		proxy.mittBus.emit('onSignInClick')
	}, 300)
}

const cutType = (val: LogoType) => {
	emits('change', val)
}

const clear = () => {
	setTimeout(() => {
		ruleFormRef.value.clearValidate()
	})
}

const getSms = (codeObj) => {
	login_form.value.code = codeObj.code
	login_form.value.areaCode = codeObj.area_code
	onSignIn()
}
const getMfa = (code: string) => {
	login_form.value.code = code
	onSignIn()
}
</script>

<style scoped lang="scss">
.account-form {
	.slogan {
		margin-top: 20px;
		color: #666;
	}

	.text-center {
		text-align: center;
	}

	.form {
		position: relative;
		z-index: 1;
		margin-top: 20px;

		.form-btn {
			.not-pass {
				margin-bottom: 22px;
				color: var(--color-primary);
				text-align: right;
				cursor: pointer;
			}

			button {
				width: 100%;
				margin-top: 20px;
			}

			.regist {
				display: flex;
				justify-content: space-between;
				margin-top: 15px;

				span {
					color: var(--color-primary);
					cursor: pointer;
				}
			}

			.hw_pass {
				margin-top: 30px;
				color: #666;
				text-align: center;
				cursor: pointer;
			}
		}

		.el-image {
			cursor: pointer;
			border: 1px solid #dcdfe6;
			border-radius: var(--border-radius);
		}
	}
}
</style>
